// docs: https://white-light.feishu.cn/wiki/PDsbw8tg3irFxGkV8wVcLOJUnMc

/** ---------------------------------------------------------------- */
/** 枚举定义（来自 app_base.thrift） */
/** ---------------------------------------------------------------- */

/** 首页数据刷新方式 */
export enum ERefreshType {
    /** 下拉刷新 */
    PullRefresh = 1,
    /** 上拉加载 */
    PullLoad = 2,
}

/** 首页模块类型 */
export enum EModuleType {
    /** 信息流 */
    Feed = 1,
    /** 新 */
    New = 2,
    /** 热 */
    Hot = 3,
}

/** feed 标签 */
export enum EDramaTag {
    /** 新 */
    New = 1,
    /** 热 */
    Hot = 2,
    /** 独家 */
    Exclusive = 3,
}

/** feed 场景 */
export enum EFeedScene {
    /** 信息流 */
    Default = 0,
    /** 会员页 */
    Member = 1,
    /** 播放退出挽留 */
    VideoExit = 2,
    /** 剧末挽留1（android） */
    DramaEnd = 3,
    /** 剧末挽留2（ios） */
    DramaEndX = 4,
}

/** ---------------------------------------------------------------- */
/** 公共结构 */
/** ---------------------------------------------------------------- */

/** 播放信息 */
export interface IPlayInfo {
    url: string;
    title: string;
    drama_id: string;
    chapter_id: string;
}

/** 短剧数据 */
export interface IDrama {
    /** 短剧 ID */
    drama_id: string;
    /** 封面信息 */
    cover_url: string;
    /** 短剧标题 */
    title: string;
    /** 短剧分类列表 */
    category_list: string[];
    /** 热度数据 */
    attention: string;
    /** 短剧角标 */
    tag: EDramaTag;
    /** 播放信息 */
    play_info: IPlayInfo;
    /** 用户是否已收藏 */
    is_followed: boolean;
    /** 埋点数据 */
    track?: Record<string, string>;
    /** 描述 */
    description: string;
}

/** ---------------------------------------------------------------- */
/** GetDramaMallFeeds */
/** ---------------------------------------------------------------- */

/** 获取短剧 feed 请求参数 */
export interface IGetDramaMallFeedsParams {
    /** 请求携带上次返回的 cursor */
    cursor: string;
    /** 每页请求的数据量 */
    page_size: number;
    /** 刷新方式（该接口暂未使用，保留扩展能力） */
    refresh_type: ERefreshType;
    /** 接口场景（用于区分数据源） */
    scene: EFeedScene;
}

/** 获取短剧 feed 响应数据 */
export interface IGetDramaMallFeedsData {
    /** Feed 列表 */
    feeds: IDrama[];
    /** 游标，下一页数据的第一条排序数 */
    cursor: string;
    /** 是否还有数据 */
    has_next: boolean;
}

/** 获取短剧 feed 响应 */
export type TGetDramaMallFeedsResponse = IGetDramaMallFeedsData;

/** ---------------------------------------------------------------- */
/** GetDramaMallHome */
/** ---------------------------------------------------------------- */

/** 获取短剧首页请求参数 */
export interface IGetDramaMallHomeParams {
    /**
     * 刷新方式（1:下拉刷新, 2:上拉加载）
     * 下拉刷新返回全部模块数据，上拉加载返回指定模块数据
     */
    refresh_type: ERefreshType;
    /** 模块类型（仅上拉加载时需要） */
    module_type: EModuleType;
    /** 请求携带上次返回的 cursor（仅上拉加载时需要） */
    cursor: string;
    /** 每页请求的数据量（仅上拉加载时需要） */
    page_size: number;
}

/** 短剧首页模块 */
export interface IDramaHomeModule {
    type: EModuleType;
    name: string;
    dramas: IDrama[];
    cursor: string;
    has_next: boolean;
}

/** 获取短剧首页响应数据 */
export interface IGetDramaMallHomeData {
    modules: IDramaHomeModule[];
}

/** 获取短剧首页响应 */
export type TIGetDramaMallHomeResponse = IGetDramaMallHomeData;
